<template>
  <div class="loader"
    :style="{
      height: size,
      width: size,
    }"
    :class="[classes, {
      'loader-white': color === 'white',
      'loader-tiny': tiny
    }]"
  ></div>
</template>

<script>
export default {
  name: 'spin-loader',
  props: {
    color: {
      type: String,
      required: false,
    },
    tiny: {
      type: Boolean,
      required: false,
    },
    size: {
      type: String,
      required: false,
      default: '48px',
    },
    classes: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.loader {
  width: 48px;
  height: 48px;
  border: 3px solid $legacy-primary;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  animation: rotation 1s linear infinite;
}

.loader-tiny {
  width: 25px;
  height: 25px;
}

.loader-white {
  border: 3px solid $white;
  border-bottom-color: transparent;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
